import api from './axios';

export const getDietPlan = (userId) => api.get(`/diet-plans/admin/${userId}`);
export const saveDietPlan = (userId, data) => api.put(`/diet-plans/admin/${userId}`, data);
// Generating a seven-day Iranian meal catalogue can take longer than the
// default admin API timeout; keep the rest of the panel fast.
export const generateDietPlan = (userId) => api.post(`/diet-plans/admin/${userId}/generate`, {}, { timeout: 150000 });
export const uploadDietPlanPdf = (userId, file) => {
  const form = new FormData();
  form.append('file', file);
  return api.post(`/diet-plans/admin/${userId}/pdf`, form, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const getNutritionKnowledgeBase = () => api.get('/diet-plans/knowledge-base');
export const saveNutritionKnowledgeBase = (data) => api.put('/diet-plans/knowledge-base', data);
